import {AvatarGroup, Stack, StackProps} from '@mui/material';
import {fadeIn} from '../../../../../../../../utils/css-animations';
import {UserAvatar} from '../../shared/user-avatar';

export const plannerListTextSx = {
  fontWeight: 500,
  fontSize: '16px',
  color: 'gray.main',
} as const;

export function PlannerListRow({selected, sx, ...props}: StackProps & {selected?: boolean}) {
  return (
    <Stack
      flexDirection="row"
      alignContent="center"
      alignItems="center"
      height="42px"
      paddingX="4px"
      {...props}
      sx={{
        animation: `${fadeIn} 0.3s`,
        backgroundColor: selected ? 'blue.hover' : undefined,
        '&:hover': {
          backgroundColor: 'blue.hover',
          cursor: 'pointer',
          borderRadius: '5px',
        },
        ...sx,
      }}
    />
  );
}

type AvatarUser = {id: string; name: string; picture?: string; socialResponses?: string[]};

export function PlannerListAvatars({users}: {users: AvatarUser[]}) {
  return (
    <Stack flex="1" flexDirection="row" alignItems="center" minWidth="120px" marginRight="15px">
      <AvatarGroup
        total={users.length}
        spacing="small"
        sx={{
          '& > .MuiAvatar-root': {marginLeft: '-15px'},
          '& > .MuiAvatar-colorDefault:not(:has(svg))': {
            background: 'none',
            border: 'none',
            color: 'black',
            paddingLeft: '6px',
            fontSize: '16px',
            fontWeight: 500,
            marginLeft: '-5px !important',
          },
        }}
      >
        {users.slice(0, 3).map((user, index) => (
          <UserAvatar
            size="l"
            key={`${index}_${user.id}`}
            name={user.name}
            picture={user.picture}
            socialResponses={user.socialResponses}
          />
        ))}
      </AvatarGroup>
    </Stack>
  );
}
